<style src="./BlockNavigation.scss" lang="scss"></style>

<script>
	export default {
		name: 'HpBlockNavigation',
		props: ['headline', 'link', 'list'],
		data() {
			return {};
		},
		methods: {
			showhideHandler() {
				let border = document.documentElement.style.getPropertyValue('--grid-border').replace(/\D/g, '');
				let space = this.$el.offsetWidth - border;
				let list = this.$el.querySelectorAll('nav ul li');
				let len = list.length;
				for (let i = len - 1; i > 0; i--) {
					list[i].style.visibility = '';
				}
				for (let i = len - 1; i > 0; i--) {
					let tmp = list[i];
					tmp.style.visibility = space < tmp.offsetLeft + tmp.offsetWidth ? 'hidden' : '';
				}
			}
		},
		mounted() {
			setTimeout(this.showhideHandler, 700);
			document.addEventListener('colCountChanged', () => {
				setTimeout(this.showhideHandler, 700);
			});
		}
	};
</script>

<template>
	<div data-component="block-navigation" data-grid-row>
		<h2>
			<a :href="link">
				{{ headline }}
			</a>
		</h2>
		<nav>
			<ul data-grid-row>
				<li v-for="(element, index) in list" :key="index">
					<a :href="element.link">
						{{ element.text }}
					</a>
				</li>
			</ul>
		</nav>
	</div>
</template>
